/*
 * @Author: wp
 * @Date: 2022-12-29 15:31:28
 * @LastEditors: 万鹏
 * @LastEditTime: 2022-12-29 15:34:55
 * @Descripttion:
 */
import { parseTime } from '@/utils/validate'

export default {
    GOODS_TYPE: {
        ACCOUNT: 6, // 账号
        ID: 7, // id
        SHIPIN: 8
    },
    CONFIG: {
        config_1: 'config_1', // 咨询客服链接
        config_2: 'config_2', // 咨询客服QQ
        config_3: 'config_3', // 游戏租号链接
        config_4: 'config_4', // 充值超额提示客服
        config_5: 'config_5', // 充值超额提示收款支付宝
        config_6: 'config_6', // 充值超额提示客服链接
        config_7: 'config_7', // 回收客服链接
        config_8: 'config_8', // h5下载app地址
        config_9: 'config_9', // 充值最高金额
        config_10: 'config_10' // id客服vx
    },
    payPassLength: 6, // 支付密码长度
    getOssAuthTime: 1680000, // 获取oss时间(28分钟)
    OSS_UPLOAD_PATH: {
        avatar: fileStr('/user/head/'), // 头像
        cover: fileStr('/goods/cover/'), // 商品封面
        goodsDetails: fileStr('/goods/detail/'), // 商品详情图
        idCard: fileStr('/user/idcard/'), // 身份证
        game: fileStr('/game/'), // 游戏图片
        other: fileStr('/operate/') // banner图片及其它
    }
}

function fileStr(str) {
    return str + parseTime(new Date(), '{y}{m}{d}/')
}
